import "./App.css";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Login from "./Pages/Home/Authentication/Login/Login";
import Registration from "./Pages/Home/Authentication/Registration/Registration";
import NoAuthLayout from "./Pages/NoAuthLayout";
import AuthLayout from "./Pages/AuthLayout";
import DashboardDash from "./Pages/DashboardSideBar/DashboardDash/DashboardDash";
import UploadEvent from "./Pages/DashboardSideBar/UploadEvent/UploadEvent";
import Testimonials from "./Pages/DashboardSideBar/Testimonials/Testimonials";
import SocialMedia from "./Pages/DashboardSideBar/SocialMedia/SocialMedia";
import EditProfile from "./Pages/DashboardSideBar/EditProfile/EditProfile";
import EducatedIndividual from "./Pages/DashboardSideBar/EducatedIndividual/EducatedIndividual";
import OtherActivities from "./Pages/DashboardSideBar/OtherActivities/OtherActivities";
import Hero from "./Pages/Home/Hero/Hero";
import Ambassador from "./Pages/DashboardSideBar/AdminPages/AmbassadorData/AmbassadorData";
import Slogan from "./Pages/DashboardSideBar/AdminPages/Slogan/Slogan";
import OtherActivity from "./Pages/DashboardSideBar/AdminPages/OtherActivity/OtherActivity";
import Gallery from "./Pages/DashboardSideBar/AdminPages/Gallery/Gallery";
// import Video from './Pages/DashboardSideBar/AdminPages/Video/Video';
import Evaluation from "./Pages/DashboardSideBar/AdminPages/Evaluation/Evaluation";
import Allocation from "./Pages/DashboardSideBar/AdminPages/Allocation/Allocation";
import AuthGaurd from "./AuthGaurd";
import BestAmbassadorSelection from "./Pages/DashboardSideBar/AdminPages/BestAmbassadorSelection/BestAmbassadorSelection";
import BestAmbassador from "./Pages/DashboardSideBar/AdminPages/BestAmbassador/BestAmbassador";
import sadEmoji from "./assests/sad-emoji.webp";
import ViewSop from "./Pages/DashboardSideBar/ViewSop/ViewSop";
import AmbassadorsReport from "./Pages/DashboardSideBar/AdminPages/AmbassadorsReport/AmbassadorsReport";
import VGMReport from "./Pages/DashboardSideBar/AdminPages/VGMReport/VGMReport";
import UploadingCSV from "./Pages/DashboardSideBar/AdminPages/UploadingCSV/UploadingCSV";
import EventProgram from "./Pages/DashboardSideBar/AdminPages/EventProgram/EventProgram";

function App() {
  return (
    // <Router>
    <Routes basename="/ambassador">
      <Route path="/" element={<AuthGaurd />}>
        <Route element={<NoAuthLayout />}>
          <Route path="/" element={<Hero />} />
          <Route path="/ambassador/" element={<Hero />} />
          <Route path="/ambassador/login" element={<Login />} />
          <Route path="/ambassador/registration" element={<Registration />} />
        </Route>
        <Route element={<AuthLayout />}>
          <Route path="/ambassador/dash" element={<DashboardDash />} />
          <Route path="/ambassador/events" element={<UploadEvent />} />
          <Route path="/ambassador/testimonials" element={<Testimonials />} />
          <Route path="/ambassador/social-media" element={<SocialMedia />} />
          <Route path="/ambassador/edit-profile" element={<EditProfile />} />
          <Route
            path="/ambassador/educate-individual"
            element={<EducatedIndividual />}
          />
          <Route
            path="/ambassador/other-activities"
            element={<OtherActivities />}
          />
          <Route path="/ambassador/admin-dash" element={<Ambassador />} />
          <Route path="/ambassador/admin-slogan" element={<Slogan />} />
          <Route
            path="/ambassador/admin-other-activities"
            element={<OtherActivity />}
          />
          <Route path="/ambassador/admin-events" element={<Gallery />} />
          {/* <Route path="/ambassador/admin-video" element={<Video />} /> */}
          <Route path="/ambassador/admin-evaluation" element={<Evaluation />} />
          <Route path="/ambassador/admin-allocation" element={<Allocation />} />
          <Route
            path="/ambassador/best-ambassador-selection"
            element={<BestAmbassadorSelection />}
          />
          <Route
            path="/ambassador/best-ambassador"
            element={<BestAmbassador />}
          />
          <Route path="/ambassador/view-sop" element={<ViewSop />} />
          <Route
            path="/ambassador/ambassadors-report"
            element={<AmbassadorsReport />}
          />
          <Route path="/ambassador/vgm-report" element={<VGMReport />} />
          <Route path="/ambassador/uploading-file" element={<UploadingCSV />} />
          <Route path="/ambassador/event-program" element={<EventProgram />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
    // </Router>
  );
}

function NotFound() {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      <img
        src={sadEmoji}
        alt="Sad Emoji"
        width={70}
        style={{ marginBottom: "5px" }}
      />
      <h1 style={{ marginBottom: "0", color: "#333", marginBottom: "5px" }}>
        Page Not Found
      </h1>
      <Link to="/" style={{ textDecoration: "underline" }}>
        Go to main page
      </Link>
    </div>
  );
}

export default App;
